import { useEffect, useState } from 'react';
import { playSound, Sound } from '~/assets/sounds';
import { rage, useObservable } from '~/rage';
import { JobVehicleRentClass } from '~/shared';
import {
	setVehicleTabClass,
	setVehicleTabIndex,
	setVehicleTabMaxIndex,
	useLayoutDispatch,
	useLayoutSelector,
} from '../../redux';
import { JobRentVehicleItem } from '../Car';
import { Tab } from '../Tab';
import { TabButton } from '../TabButton';
import { TabsContainer } from '../TabsContainer';
import { menuTabsClassNames, menuTabsClassOrder } from './MenuTabs.model';
import { StyledMenuContainer } from './MenuTabs.styled';

const MenuTabs: React.FC = () => {
	const dispatch = useLayoutDispatch();
	const vehicleList = useLayoutSelector(
		(state) => state.modal.vehicleList,
	) as JobRentVehicleItem[];
	const withRentVehicles = useObservable(rage.jobs.getWithRentVehicles());
	const withOwnedVehicles = useObservable(rage.jobs.getWithOwnedVehicles());

	const tabIndex = useLayoutSelector((state) => state.modal.vehicleTabIndex);
	const [existingTabs, setExistingTabs] = useState<
		(JobVehicleRentClass | 'owned')[]
	>([]);

	const ownedVehicles = useObservable(rage.vehicles.getPlayerVehicleList());

	useEffect(() => {
		const tabs: (JobVehicleRentClass | 'owned')[] = [];

		if (withOwnedVehicles && ownedVehicles.length > 0) {
			tabs.push('owned');
		}

		if (withRentVehicles) {
			const rentTabs = menuTabsClassOrder.filter((vehicleClass) =>
				vehicleList.some((e) => e.class === vehicleClass),
			);
			tabs.push(...rentTabs);
		}

		dispatch(setVehicleTabMaxIndex(tabs.length - 1));
		dispatch(setVehicleTabIndex(0));

		setExistingTabs(tabs);
	}, [vehicleList, ownedVehicles, withOwnedVehicles, withRentVehicles]);

	useEffect(() => {
		const tabClass = existingTabs[tabIndex];
		dispatch(setVehicleTabClass(tabClass));
	}, [existingTabs, tabIndex]);

	return (
		<StyledMenuContainer>
			<TabButton>Q</TabButton>
			<TabsContainer>
				{existingTabs.map((vehicleClass, index) => (
					<Tab
						key={`modalTab#${index}`}
						onMouseEnter={() => playSound(Sound.LinkCursor)}
					>
						{vehicleClass === 'owned'
							? 'Мои ТС'
							: menuTabsClassNames[vehicleClass]}
					</Tab>
				))}
			</TabsContainer>
			<TabButton>E</TabButton>
		</StyledMenuContainer>
	);
};

export { MenuTabs };
